import type { ReactNode } from "react"
import { Link } from "react-router"

/**
 * Un contador que se puede abrir.
 *
 * ⚠ **Siempre es un enlace, nunca un número a secas.** Un contador que no lleva a
 * las filas que cuenta obliga a repetir el filtro a mano en la otra pantalla, y a
 * los dos días nadie lo mira. Que la prop `a` sea obligatoria es lo que impide que
 * aparezca uno decorativo.
 *
 * ⚠ **`alarma` sólo tiñe si el valor es mayor que cero.** Un cero nunca es una
 * alarma, y un panel en rojo permanente se deja de mirar a la semana.
 */
export function TarjetaNumero({
  valor,
  etiqueta,
  a,
  icono,
  alarma = false,
  prueba,
}: {
  valor: number
  etiqueta: string
  a: string
  icono: ReactNode
  alarma?: boolean
  prueba: string
}) {
  const enciende = alarma && valor > 0
  const color = enciende ? "var(--destructive)" : undefined
  return (
    <Link
      to={a}
      data-testid={prueba}
      data-exportar-kpi=""
      data-kpi-titulo={etiqueta}
      data-kpi-cantidad={String(valor)}
      className="tarjeta-interactiva relative overflow-hidden p-4"
    >
      {/* La barra del borde izquierdo, y no la tarjeta entera teñida: el número
          tiene que seguir leyéndose con el contraste del texto normal. */}
      {enciende && (
        <span
          aria-hidden={true}
          className="absolute inset-y-0 left-0 w-1"
          style={{ backgroundColor: "var(--destructive)" }}
        />
      )}
      <span className="flex items-start justify-between gap-3">
        <span className="block">
          <span
            className="block text-3xl leading-none font-semibold tabular-nums"
            style={{ color }}
          >
            {valor}
          </span>
          <span className="mt-1.5 block text-xs" style={{ color: "var(--fg-muted)" }}>
            {etiqueta}
          </span>
        </span>
        <span
          aria-hidden={true}
          className="flex h-8 w-8 shrink-0 items-center justify-center rounded-[var(--radius-control)]"
          style={{
            color: color ?? "var(--primary-texto)",
            backgroundColor: enciende
              ? "color-mix(in oklab, var(--destructive) 12%, transparent)"
              : "var(--primary-suave)",
          }}
        >
          {icono}
        </span>
      </span>
    </Link>
  )
}
